export function isOnlyTherapist(user) {
    return (user?.isTherapist && !user?.isAdmin);
}

function getTherapistId(therapistRef) {
    if (!therapistRef) return null;
    return therapistRef._id || therapistRef;
}

export function canSendWelcomeEmail(user, client) {
    return canSendAppointmentEmail(user, client, 1);
}

export function canSendAppointmentEmail(user, client, block) {
    if (!user) return false;
    if (user?.isAdmin) return true;
    const blockNum = Number(block);
    if (![1, 2, 3].includes(blockNum)) return false;
    const blockTherapist = getTherapistId(
        client?.therapeuticGroup?.[`block${blockNum}`]?.therapist,
    );
    return blockTherapist === user?._id || String(blockTherapist) === String(user?._id);
}

/** Lowest block (1–3) assigned to the user for this client, or null. */
export function getUserBlockForClient(user, client) {
    if (!user || !client?.therapeuticGroup) return null;
    for (const blockNum of [1, 2, 3]) {
        if (canSendAppointmentEmail(user, client, blockNum) && !user?.isAdmin) {
            const blockTherapist = getTherapistId(
                client.therapeuticGroup[`block${blockNum}`]?.therapist,
            );
            if (blockTherapist === user?._id || String(blockTherapist) === String(user?._id)) {
                return blockNum;
            }
        }
    }
    if (user?.isAdmin) return 1;
    return null;
}

export function getAppointmentEmailSentAt(client, block) {
    const blockNum = Number(block);
    if (blockNum === 1) return client?.welcomeEmailSentAt;
    if (blockNum === 2) return client?.block2EmailSentAt;
    if (blockNum === 3) return client?.block3EmailSentAt;
    return null;
}

export function isAppointmentEmailEligible(client, block) {
    const blockNum = Number(block);
    if (blockNum === 1) return true;
    if (blockNum === 2) return !!client?.block1Done;
    if (blockNum === 3) return !!client?.block2Done;
    return false;
}

export function canShowAppointmentEnvelope(user, client) {
    if (!user || !client || client?.finalized) return false;
    if (user?.isAdmin) return true;
    return getUserBlockForClient(user, client) != null;
}

export function canManageAppointments(user, client) {
    return canShowAppointmentEnvelope(user, client);
}

export function getClientGroupTherapists(client) {
    const group = client?.therapeuticGroup;
    if (!group) return [];
    const seen = new Set();
    const list = [];
    for (const blockNum of [1, 2, 3]) {
        const therapist = group[`block${blockNum}`]?.therapist;
        if (!therapist || typeof therapist !== "object") continue;
        const id = therapist._id;
        if (!id || seen.has(String(id))) continue;
        seen.add(String(id));
        list.push(therapist);
    }
    return list;
}

export function getTherapistForBlock(client, blockNum) {
    return client?.therapeuticGroup?.[`block${blockNum}`]?.therapist || null;
}

export function getNextIncompleteBlock(client) {
    if (!client?.block1Done) return 1;
    if (!client?.block2Done) return 2;
    if (!client?.block3Done) return 3;
    return 1;
}

export function therapistLabel(therapist) {
    if (!therapist) return "";
    const name = `${therapist.fullName || ""} ${therapist.surname || ""}`.trim();
    return therapist.acronym ? `${therapist.acronym} · ${name}` : name;
}
